module.exports = __webpack_public_path__ + "img/tip.cd64fd13.png";